export function amount(amount, decimals) {
  const factor = Math.pow(10, decimals);
  return (Number(amount) / factor).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
